import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { rootReducer } from "./reducers";
import { createStore } from "redux";

window.onbeforeunload = (event) => {
  const e = event || window.event;
  // Cancel the event
  e.preventDefault();
  if (e) {
    e.returnValue = ''; // Legacy method for cross browser support
  }
  return ''; // Legacy method for cross browser support
};

//GGS link: https://docs.google.com/spreadsheets/d/1Y2qtsAGaYNYQx5OMEdYTmZIFyXmTHBoytYUYPNbjmCY/edit#gid=0
// const ggs_options = {
//   apiKey: "AIzaSyAAjmWOBD6T-1BcwMwiFSgj1kvrEkXvLEU",
//   sheetId: "1Y2qtsAGaYNYQx5OMEdYTmZIFyXmTHBoytYUYPNbjmCY",
//   sheetNumber: 1,
//   sheetName: "Question Types",
//   // returnAllResults: false,
// };

window.QuestionTypes = {};
window.DisableQuestion = {};

handleGsheetReader("https://sheets.googleapis.com/v4/spreadsheets/1Y2qtsAGaYNYQx5OMEdYTmZIFyXmTHBoytYUYPNbjmCY/values:batchGet?ranges=ThemeConfig!A1:Z1000&ranges=ExpressionFunction!A1:Z1000&ranges=GroupName!A1:Z1000&ranges=AppearanceKey!A1:Z1000&ranges=Choices!A1:Z1000&ranges='Question Types'!A1:AB1000&ranges=Widgets!A1:AN1002&dateTimeRenderOption=FORMATTED_STRING&majorDimension=ROWS&valueRenderOption=FORMATTED_VALUE&key=AIzaSyAAjmWOBD6T-1BcwMwiFSgj1kvrEkXvLEU")
.then((datas) => {

  let count = 0;
  datas.valueRanges.forEach((data)=>{
    if(data.range.indexOf("Question Types")>-1){
      window.FormEl = processGSheetResults(data)
    }else if(data.range.indexOf("Widgets")>-1){
      window.GroupTemplateQuestions = handleQuestionTemplateGroup(processGSheetResults(data))
    }else if(data.range.indexOf("Choices")>-1){
      window.Choices = data
      window.ListNameDefault = []
      processGSheetResults(data).forEach((choice)=>{
          if(window.ListNameDefault.indexOf(choice.list_name)===-1){
            window.ListNameDefault = [...window.ListNameDefault,choice.list_name]
          }
      })
    }else if(data.range.indexOf("AppearanceKey")>-1){
      window.AppearanceString = (processGSheetResults(data))
    }else if(data.range.indexOf("ExpressionFunction")>-1){
      window.ExpressionFunction = (processGSheetResults(data))
    }else if(data.range.indexOf("GroupName")>-1){
      window.GroupName = (processGSheetResults(data))
    }else if(data.range.indexOf("ThemeConfig")>-1){
      window.ThemeConfig = processGSheetResults(data)
    }
    
    count++;
    if (count === datas.valueRanges.length) {
      const store = createStore(rootReducer);

      const root = ReactDOM.createRoot(document.getElementById("root"));
      root.render(
          <Provider store={store}>
            <App key="form-builder-app" />
          </Provider> 
      );
    }
  })
  
}).catch((error) => {
  console.error(error)
});


function handleQuestionTemplateGroup(data){
  let quesGroup= {}
  let quesGroupTemp = {}
  window.GroupTemplateParent = {}
  data.forEach((ques)=>{
      if(ques.type === 'begin group' || ques.type === 'begin template'){
          quesGroupTemp[ques.AppearanceGroup] = []
          window.GroupTemplateParent[ques.AppearanceGroup] = ques
      }else if(ques.type === 'end group' || ques.type === 'end template'){
          quesGroup = {...quesGroup,...quesGroupTemp}
          quesGroupTemp = {}
      }else if(ques.type){
          quesGroupTemp[Object.keys(quesGroupTemp)] = [...quesGroupTemp[Object.keys(quesGroupTemp)],ques]
      }
  })
  return quesGroup
}

async function handleGsheetReader(url = '') {
  const response = await fetch(url)
  return response.json()
}


function processGSheetResults(JSONResponse) {
  var data = JSONResponse.values;
  var startRow = 1; // skip the header row(1), don't need it

  var processedResults = [{}];
  var colNames = {};

  for (var i = 0; i < data.length; i++) {
    // Rows
    var thisRow = data[i];

    for (var j = 0; j < thisRow.length; j++) {
      // Columns/cells
      var cellValue = thisRow[j];
      var colNameToAdd = colNames[j]; // this will be undefined on the first pass

      if (i < startRow) {
        colNames[j] = cellValue;
        continue; // skip the header row
      }

      if (typeof processedResults[i] === 'undefined') {
        processedResults[i] = {};
      }

      if (typeof colNameToAdd !== 'undefined' && colNameToAdd.length > 0) {
        processedResults[i][colNameToAdd] = cellValue;
      }
    }
  } // make sure we're only returning valid, filled data items


  processedResults = processedResults.filter(function (result) {
    return Object.keys(result).length;
  }); // if we're not filtering, then return all results

  return processedResults
}

reportWebVitals();
